
import { RevPicker } from '@backmarket/design-system'
import isEmpty from 'lodash/isEmpty'

import { trackClick } from '@tracking/events'

import ColorRound from './ColorRound'
import { PICKER_ICONS } from './Picker.constants'
import translations from './Picker.translations'

export default {
  components: {
    RevPicker,
  },
  props: {
    label: {
      type: String,
      required: true,
    },
    trackingId: {
      type: String,
      default: '',
    },
    trackingValue: {
      type: String,
      default: '',
    },
    link: {
      type: Object,
      required: true,
    },
    available: {
      type: Boolean,
      required: true,
    },
    selected: {
      type: Boolean,
      required: true,
    },
    icon: {
      type: String,
      default: '',
    },
    color: {
      type: String,
      default: '',
    },
    price: {
      type: Object,
      default: () => ({}),
    },
    goodDeal: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    disabled() {
      return !this.available
    },
    description() {
      if (isEmpty(this.price)) {
        return ''
      }

      return this.disabled
        ? this.$t(translations.soldOut)
        : this.$t.price(this.price)
    },
    tag() {
      return this.goodDeal ? this.$t(translations.goodDeal) : ''
    },
    pickerIcon() {
      if (this.icon && Object.keys(PICKER_ICONS).includes(this.icon)) {
        return PICKER_ICONS[this.icon]
      }

      if (this.color) {
        return ColorRound
      }

      return undefined
    },
    pickerIconProps() {
      if (!this.icon && this.color) {
        return { color: this.color }
      }

      return {}
    },
  },
  methods: {
    onClick() {
      if (this.disabled || this.selected) {
        return
      }

      if (!this.trackingId || !this.trackingValue) {
        return
      }

      trackClick({
        zone: this.trackingId,
        name: this.trackingValue,
      })
    },
  },
}
